export enum DayScheduler {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 0,
}

export const DaySchedulerMapping = {
  [DayScheduler.Sunday]: 'Sun',
  [DayScheduler.Monday]: 'Mon',
  [DayScheduler.Tuesday]: 'Tue',
  [DayScheduler.Wednesday]: 'Wed',
  [DayScheduler.Thursday]: 'Thu',
  [DayScheduler.Friday]: 'Fri',
  [DayScheduler.Saturday]: 'Sat',
};

export enum WeekOfMonth {
  First = 1,
  Second = 2,
  Third = 3,
  Fourth = 4,
}
